import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-bottom: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const Header = styled.button.attrs({ className: 'nodrag nopan' })`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  background: transparent;
  border: 0;
  padding: 2px 0;
  cursor: pointer;
  outline: none;
  text-align: left;
`;

export const Title = styled.span`
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#A1A3B8'};
`;

export const Bullet = styled.span`
  font-size: 10px;
  line-height: 1;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#A1A3B8'};
  opacity: 0.55;
`;

export const Subtitle = styled.span`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#A1A3B8'};
  opacity: 0.7;
`;

export const Chevron = styled.span<{ $expanded: boolean }>`
  margin-left: auto;
  display: inline-flex;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#A1A3B8'};
  transition: transform 140ms ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '180deg' : '0deg')});

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Grid 0fr -> 1fr animates the body open/closed without JS measurement.
export const BodyWrapper = styled.div<{ $expanded: boolean }>`
  display: grid;
  grid-template-rows: ${({ $expanded }) => ($expanded ? '1fr' : '0fr')};
  transition: grid-template-rows 160ms ease;
`;

export const BodyInner = styled.div`
  overflow: hidden;
  min-height: 0;
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
`;
